import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import type { UerCreateClosingWorkOrderChangeMutation, WorkOrderChangeClosingInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateClosingWorkOrderChangeGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerCreateClosingWorkOrderChange';

interface IUseUerCreateClosingWorkOrderChange {
    workOrderId: number;
    onSuccess: (workOrderChanngeId: number) => void;
}

export const useUerCreateClosingWorkOrderChange = (props: IUseUerCreateClosingWorkOrderChange) => {
    const dispatch = useDispatch();
    const { workOrderId, onSuccess } = props;

    const onSuccessLocal = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerCreateClosingWorkOrderChangeMutation>) => {
            const workOrderChangeId = depsVars?.payload?.uerCreateClosingWorkOrderChange?.data?.id;

            if (workOrderChangeId) {
                onSuccess(workOrderChangeId);
            }
        },
        [onSuccess],
    );

    const [, uerCreateClosingWorkOrderChangeStatus, , uerCreateClosingWorkOrderChangeRequest] =
        useRequest<UerCreateClosingWorkOrderChangeMutation>({
            requestId,
            query: uerCreateClosingWorkOrderChangeGql,
            withEffect: false,
            dependenciesUpdater: onSuccessLocal,
        });

    const uerCreateClosingWorkOrderChangeMakeRequest = useCallback(
        (input: Omit<WorkOrderChangeClosingInput, 'workOrderId'>) => {
            dispatch(uerCreateClosingWorkOrderChangeRequest({ input: { ...input, workOrderId } }));
        },
        [dispatch, uerCreateClosingWorkOrderChangeRequest, workOrderId],
    );

    return { uerCreateClosingWorkOrderChangeStatus, uerCreateClosingWorkOrderChangeMakeRequest };
};
